import { render, staticRenderFns } from "./BotoesStepper.vue?vue&type=template&id=2f4865c1&"
import script from "./BotoesStepper.vue?vue&type=script&lang=js&"
export * from "./BotoesStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports